window.editFormatter = function(value, row) {
    let html = '';
    if (row.allow_edit === "0") {
        return html;
    }
    html += '<button class="action action-edit btn btn-primary btn-sm">';
    html += '<i class="fal fa-pencil me-2"></i>';
    html += __('Wijzigen');
    html += '</button>';
    return html;
};
